import React from 'react';
import {
  Box,
  Button,
  Paper,
  Typography,
  Chip,
  Stack,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Breadcrumbs,
  Link,
  IconButton,
  LinearProgress,
  Tooltip,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Switch,
  useMediaQuery,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack, Home } from '@mui/icons-material';
import HistoryIcon from '@mui/icons-material/History';
import MapIcon from '@mui/icons-material/Map';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useTheme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth } from '../contexts/AuthContext';
import { formatCpfCnpj, isValidCpfCnpj, cleanCpfCnpj, maskCnpjForDisplay } from '../utils/masks';
import PlantaViewer from '../components/PlantaViewer';
import { jsPDF } from 'jspdf';

export default function Clientes() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const handleBack = () => navigate('/');
  const { token, hasPermission, user } = useAuth();
  const isAdmin = ['admin', 'willians'].includes((user?.nivel_acesso || '').toLowerCase());
  const canCreate = hasPermission('/clientes', 'create');
  const canUpdate = hasPermission('/clientes', 'update');
  const canDelete = hasPermission('/clientes', 'delete');
  const [rows, setRows] = React.useState([]);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [total, setTotal] = React.useState(0);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [selectedCliente, setSelectedCliente] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [form, setForm] = React.useState({
    nome: '',
    cnpj: '',
    email: '',
    contato: '',
    endereco: '',
    ativo: true,
    agenda_contratos: true,
  });
  const [editForm, setEditForm] = React.useState({
    nome: '',
    cnpj: '',
    email: '',
    contato: '',
    endereco: '',
    ativo: true,
    agenda_contratos: true,
  });
  const [saving, setSaving] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = React.useState(false);

  const handleBuscarCnpj = async (cnpjValue, setter) => {
    const nums = (cnpjValue || '').replace(/\D/g, '');
    if (nums.length !== 14) {
      alert('Informe um CNPJ válido com 14 dígitos para buscar.');
      return;
    }
    setBuscandoCnpj(true);
    try {
      const resp = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${nums}`);
      if (!resp.ok) {
        const err = await resp.json().catch(() => null);
        throw new Error(err?.message || 'CNPJ não encontrado');
      }
      const data = await resp.json();
      setter((f) => ({
        ...f,
        nome: data.razao_social || f.nome,
        email: data.email && data.email !== 'null' ? data.email : f.email,
        contato: data.ddd_telefone_1
          ? `(${data.ddd_telefone_1.substring(0, 2)}) ${data.ddd_telefone_1.substring(2)}`
          : f.contato,
        endereco:
          [
            data.logradouro,
            data.numero,
            data.complemento,
            data.bairro,
            data.municipio ? `${data.municipio}/${data.uf}` : '',
            data.cep ? `CEP ${data.cep}` : '',
          ]
            .filter(Boolean)
            .join(', ') || f.endereco,
      }));
    } catch (e) {
      alert('Erro ao buscar CNPJ: ' + e.message);
    } finally {
      setBuscandoCnpj(false);
    }
  };
  const [openBudgetModal, setOpenBudgetModal] = React.useState(false);
  const [budgetForm, setBudgetForm] = React.useState({ budget: '', motivo: '' });
  const [budgetHistorico, setBudgetHistorico] = React.useState([]);
  const [openHistoricoModal, setOpenHistoricoModal] = React.useState(false);
  // Planta (multi-plantas)
  const [openPlantaModal, setOpenPlantaModal] = React.useState(false);
  const [_plantaChamados, setPlantaChamados] = React.useState([]);
  const [plantaLoading, setPlantaLoading] = React.useState(false);
  const [uploadingPlanta, setUploadingPlanta] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState(0);
  const plantaInputRef = React.useRef(null);
  const [plantasList, setPlantasList] = React.useState([]);
  const [selectedPlantaId, setSelectedPlantaId] = React.useState(null);
  const [plantaUploadNivel, setPlantaUploadNivel] = React.useState('');
  const [showArquivadas, setShowArquivadas] = React.useState(false);
  const [plantasArquivadas, setPlantasArquivadas] = React.useState([]);
  const NIVEIS_PLANTA = [
    { value: 'terreo', label: 'Térreo' },
    { value: '1_subsolo', label: '1º Subsolo' },
    { value: '2_subsolo', label: '2º Subsolo' },
    { value: 'pavimento_superior', label: 'Pavimento Superior' },
    { value: 'mezanino', label: 'Mezanino' },
    { value: 'doca', label: 'Doca' },
    { value: 'cobertura', label: 'Cobertura' },
  ];
  const API = '/api';

  const loadPersisted = React.useCallback(async () => {
    setLoading(true);
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      // Verificar quais clientes o usuário tem acesso
      let clienteIds = null;
      try {
        const meResponse = await fetch(`${API}/me/clientes`, { headers });
        if (meResponse.ok) {
          const meData = await meResponse.json();
          clienteIds = meData.clientes || [];
        }
      } catch (e) {
        console.warn('Endpoint /me/clientes não disponível');
      }

      // Remove trailing slash to match Rails routes
      const resp = await fetch(`${API}/clientes`, { headers });
      if (!resp.ok) {
        console.error('Failed to fetch clientes:', resp.status, resp.statusText);
        return;
      }
      let data = await resp.json();
      console.log('Clientes data:', data);
      if (!data) return;
      // Ensure data is an array. If it's wrapped in { data: [...] } or similar, adjust here.
      let list = Array.isArray(data) ? data : data.data || [];

      // Filtrar se houver restrição
      if (clienteIds && clienteIds.length > 0) {
        list = list.filter((c) => clienteIds.map(Number).includes(Number(c.id)));
      }

      const clientesData = list.map((r, i) => ({ id: r.id ?? i + 1, ...r }));
      setRows(clientesData);
      setFilteredRows(clientesData);
      setTotal(clientesData.length);
    } catch (e) {
      console.error(e);
      alert('Erro ao carregar clientes');
    } finally {
      setLoading(false);
    }
  }, [API, token]);

  // Função para filtrar clientes
  const handleSearch = React.useCallback(
    (term) => {
      setSearchTerm(term);
      setPage(0); // Reset para primeira página

      if (!term.trim()) {
        setFilteredRows(rows);
        setTotal(rows.length);
        return;
      }

      const filtered = rows.filter((cliente) => {
        const searchLower = term.toLowerCase();
        return (
          cliente.id?.toString().includes(searchLower) ||
          cliente.nome?.toLowerCase().includes(searchLower) ||
          cliente.cnpj?.toLowerCase().includes(searchLower)
        );
      });

      setFilteredRows(filtered);
      setTotal(filtered.length);
    },
    [rows]
  );

  const clearSearch = () => {
    setSearchTerm('');
    setFilteredRows(rows);
    setTotal(rows.length);
    setPage(0);
  };

  const handleCreateCliente = async () => {
    if (!form.nome || !form.cnpj) {
      alert('Nome e CNPJ são obrigatórios');
      return;
    }

    if (!isValidCpfCnpj(form.cnpj)) {
      alert('CPF/CNPJ inválido. Use 11 dígitos (CPF) ou 14 dígitos (CNPJ).');
      return;
    }

    setSaving(true);
    try {
      const resp = await fetch(`${API}/clientes/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ ...form, cnpj: cleanCpfCnpj(form.cnpj) }),
      });
      if (!resp.ok) {
        let msg = 'Erro ao criar cliente';
        try {
          const d = await resp.json();
          msg = d.error || d.errors?.join(', ') || d.detail || msg;
        } catch {
          msg = await resp.text();
        }
        throw new Error(msg);
      }
      setOpenModal(false);
      setForm({
        nome: '',
        cnpj: '',
        email: '',
        contato: '',
        endereco: '',
        ativo: true,
        agenda_contratos: true,
      });
      await loadPersisted();
      alert('Cliente criado com sucesso!');
    } catch (e) {
      console.error(e);
      alert('Erro ao criar cliente: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateCliente = async () => {
    if (!editForm.nome || !editForm.cnpj) {
      alert('Nome e CNPJ são obrigatórios');
      return;
    }

    if (!isValidCpfCnpj(editForm.cnpj)) {
      alert('CPF/CNPJ inválido. Use 11 dígitos (CPF) ou 14 dígitos (CNPJ).');
      return;
    }

    setSaving(true);
    try {
      const resp = await fetch(`${API}/clientes/${selectedCliente.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ ...editForm, cnpj: cleanCpfCnpj(editForm.cnpj) }),
      });
      if (!resp.ok) {
        let msg = 'Erro ao atualizar cliente';
        try {
          const d = await resp.json();
          msg = d.error || d.errors?.join(', ') || d.detail || msg;
        } catch {
          msg = await resp.text();
        }
        throw new Error(msg);
      }
      setOpenEditModal(false);
      setSelectedCliente(null);
      await loadPersisted();
      alert('Cliente atualizado com sucesso!');
    } catch (e) {
      console.error(e);
      alert('Erro ao atualizar cliente: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteClienteByRow = async (cliente) => {
    if (!cliente) return;
    if (!window.confirm('Tem certeza que deseja deletar este cliente?')) return;

    setSaving(true);
    try {
      const resp = await fetch(`${API}/clientes/${cliente.id}`, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!resp.ok) {
        const error = await resp.text();
        throw new Error(error);
      }
      setSelectedCliente((prev) => (prev?.id === cliente.id ? null : prev));
      await loadPersisted();
      alert('Cliente deletado com sucesso!');
    } catch (e) {
      console.error(e);
      alert('Erro ao deletar cliente: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteCliente = async () => {
    await handleDeleteClienteByRow(selectedCliente);
  };

  const handleToggleAgendaContratos = async (cliente, checked) => {
    try {
      const payload = {
        nome: cliente.nome || '',
        cnpj: cliente.cnpj || '',
        email: cliente.email || '',
        contato: cliente.contato || '',
        endereco: cliente.endereco || '',
        ativo: cliente.ativo !== false,
        agenda_contratos: checked,
      };

      const resp = await fetch(`${API}/clientes/${cliente.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        throw new Error('Falha ao atualizar agenda de contratos');
      }

      await loadPersisted();
    } catch (e) {
      alert(e.message || 'Erro ao atualizar agenda de contratos');
    }
  };

  const openEditDialog = (cliente) => {
    setSelectedCliente(cliente);
    setEditForm({
      nome: cliente.nome || '',
      cnpj: cliente.cnpj || '',
      email: cliente.email || '',
      contato: cliente.contato || '',
      endereco: cliente.endereco || '',
      ativo: cliente.ativo !== false,
      agenda_contratos: cliente.agenda_contratos !== false,
    });
    setOpenEditModal(true);
  };

  const handleOpenBudget = (cliente) => {
    setBudgetForm({ budget: (cliente.budget || 0).toString(), motivo: '' });
    setOpenBudgetModal(true);
  };

  const handleSaveBudget = async () => {
    if (!selectedCliente) return;
    setSaving(true);
    try {
      const resp = await fetch(`${API}/clientes/${selectedCliente.id}/update_budget`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          budget: parseFloat(budgetForm.budget) || 0,
          motivo: budgetForm.motivo,
        }),
      });
      if (!resp.ok) {
        const d = await resp.json().catch(() => ({}));
        throw new Error(d.error || 'Erro ao atualizar budget');
      }
      const updated = await resp.json();
      setSelectedCliente((prev) => ({ ...prev, budget: updated.budget }));
      setOpenBudgetModal(false);
      await loadPersisted();
      alert('Budget atualizado com sucesso!');
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleOpenHistorico = async (clienteId) => {
    try {
      const resp = await fetch(`${API}/clientes/${clienteId}/budget_historico`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (resp.ok) {
        setBudgetHistorico(await resp.json());
      }
    } catch (e) {
      console.error(e);
    }
    setOpenHistoricoModal(true);
  };

  // Carregar plantas do cliente
  const loadPlantas = React.useCallback(
    async (clienteId) => {
      try {
        const resp = await fetch(`${API}/clientes/${clienteId}/plantas`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (resp.ok) {
          const data = await resp.json();
          setPlantasList(data);
          if (data.length > 0 && !selectedPlantaId) {
            setSelectedPlantaId(data[0].id);
          }
        }
      } catch (e) {
        console.error('Erro ao carregar plantas:', e);
      }
    },
    [API, token, selectedPlantaId]
  );

  const loadPlantasArquivadas = async (clienteId) => {
    try {
      const resp = await fetch(`${API}/clientes/${clienteId}/plantas?incluir_arquivadas=true`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (resp.ok) {
        const data = await resp.json();
        setPlantasArquivadas(data.filter((p) => p.arquivada));
      }
    } catch (e) {
      console.error('Erro plantas arquivadas:', e);
    }
  };

  const handleOpenPlanta = async (clienteId) => {
    setPlantaLoading(true);
    setOpenPlantaModal(true);
    try {
      const resp = await fetch(`${API}/clientes/${clienteId}/planta_chamados`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (resp.ok) {
        const data = await resp.json();
        setPlantasList(data.plantas || []);
        setPlantaChamados(data.chamados || []);
        if (data.plantas?.length > 0) {
          setSelectedPlantaId(data.plantas[0].id);
        }
      }
    } catch (e) {
      console.error('Erro ao carregar planta:', e);
    } finally {
      setPlantaLoading(false);
    }
  };

  const handleUploadPlanta = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file || !selectedCliente || !plantaUploadNivel) {
      if (!plantaUploadNivel) alert('Selecione o nível da planta antes de enviar.');
      return;
    }
    setUploadingPlanta(true);
    setUploadProgress(0);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('nivel', plantaUploadNivel);
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', (evt) => {
      if (evt.lengthComputable) {
        const pct = Math.round((evt.loaded / evt.total) * 90);
        setUploadProgress(pct);
      }
    });
    xhr.addEventListener('load', async () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        setUploadProgress(100);
        await loadPlantas(selectedCliente.id);
        setPlantaUploadNivel('');
        setTimeout(() => {
          setUploadingPlanta(false);
          setUploadProgress(0);
        }, 800);
      } else {
        let msg = 'Erro ao enviar planta';
        try {
          const err = JSON.parse(xhr.responseText);
          msg = err.error || msg;
        } catch {}
        alert(msg);
        setUploadingPlanta(false);
        setUploadProgress(0);
      }
      if (plantaInputRef.current) plantaInputRef.current.value = '';
    });
    xhr.addEventListener('error', () => {
      alert('Erro de rede ao enviar planta');
      setUploadingPlanta(false);
      setUploadProgress(0);
      if (plantaInputRef.current) plantaInputRef.current.value = '';
    });
    xhr.open('POST', `${API}/clientes/${selectedCliente.id}/plantas`);
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.send(formData);
  };

  const handleArquivarPlanta = async (plantaId) => {
    if (!selectedCliente) return;
    if (!window.confirm('Arquivar esta planta? Ela ficará em Plantas Arquivadas.')) return;
    try {
      const resp = await fetch(
        `${API}/clientes/${selectedCliente.id}/plantas/${plantaId}/arquivar`,
        {
          method: 'PATCH',
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      if (resp.ok) {
        await loadPlantas(selectedCliente.id);
      }
    } catch (err) {
      alert('Erro ao arquivar planta: ' + err.message);
    }
  };

  const handleDesarquivarPlanta = async (plantaId) => {
    if (!selectedCliente) return;
    try {
      const resp = await fetch(
        `${API}/clientes/${selectedCliente.id}/plantas/${plantaId}/desarquivar`,
        {
          method: 'PATCH',
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      if (resp.ok) {
        await loadPlantas(selectedCliente.id);
        await loadPlantasArquivadas(selectedCliente.id);
      }
    } catch (err) {
      alert('Erro ao desarquivar: ' + err.message);
    }
  };

  const handleRemoverPlanta = async (plantaId) => {
    if (!selectedCliente) return;
    if (!window.confirm('Tem certeza que deseja excluir permanentemente esta planta?')) return;
    try {
      const resp = await fetch(`${API}/clientes/${selectedCliente.id}/plantas/${plantaId}`, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (resp.ok) {
        await loadPlantas(selectedCliente.id);
      }
    } catch (err) {
      alert('Erro ao remover planta: ' + err.message);
    }
  };

  const handleBaixarPlantaPDF = async (planta) => {
    if (!selectedCliente || !planta.planta_imagem) {
      alert('Dados insuficientes para gerar PDF');
      return;
    }

    try {
      const imgResponse = await fetch(planta.planta_imagem);
      const blob = await imgResponse.blob();
      const reader = new FileReader();

      reader.onload = () => {
        const base64Image = reader.result;
        const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        pdf.setFontSize(14);
        pdf.text(`${selectedCliente.nome}`, 15, 15);

        pdf.setFontSize(11);
        pdf.text(`Nível: ${planta.nivel_display}`, 15, 25);
        if (planta.nome) {
          pdf.text(`Pavimento: ${planta.nome}`, 15, 32);
        }

        const dataAtual = new Date().toLocaleDateString('pt-BR');
        pdf.setFontSize(9);
        pdf.text(`Data: ${dataAtual}`, 15, pageHeight - 10);

        const imgWidth = pageWidth - 30;
        const imgHeight = (pageHeight - 45) * 0.8;
        const imageFormat = blob.type === 'image/png' ? 'PNG' : 'JPEG';
        pdf.addImage(base64Image, imageFormat, 15, 40, imgWidth, imgHeight);

        const dataFormatada = new Date().toISOString().split('T')[0];
        const filename = `${selectedCliente.nome}_${planta.nivel_display}_${dataFormatada}.pdf`;
        pdf.save(filename);
      };

      reader.readAsDataURL(blob);
    } catch (err) {
      console.error('Erro ao gerar PDF:', err);
      alert('Erro ao gerar PDF da planta: ' + err.message);
    }
  };

  React.useEffect(() => {
    loadPersisted();
  }, [loadPersisted]);

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Carregar plantas quando selecionar um cliente
  React.useEffect(() => {
    if (selectedCliente?.id) {
      loadPlantas(selectedCliente.id);
      setShowArquivadas(false);
      setPlantasArquivadas([]);
      setPlantaUploadNivel('');
    }
  }, [selectedCliente?.id, loadPlantas]);

  // Atualizar pesquisa quando os dados mudarem
  React.useEffect(() => {
    if (searchTerm) {
      handleSearch(searchTerm);
    }
  }, [rows, searchTerm, handleSearch]);

  // Cabeçalho e ações responsivos
  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        minHeight: '100vh',
        p: { xs: 1, sm: 2, md: 4 },
      }}
    >
      <Box sx={{ maxWidth: { xs: '100%', xl: 1600 }, mx: 'auto', mt: { xs: 1, md: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, md: 2 } }}>
          <IconButton onClick={handleBack} size="small" aria-label="Voltar ao Dashboard">
            <ArrowBack />
          </IconButton>
          <Breadcrumbs separator="/" sx={{ ml: 1, '& .MuiBreadcrumbs-separator': { mx: 0.5 } }}>
            <Link
              underline="hover"
              color="inherit"
              onClick={handleBack}
              sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              <Home sx={{ mr: 0.5 }} fontSize="inherit" />
              Dashboard
            </Link>
            <Typography color="text.primary">Clientes</Typography>
          </Breadcrumbs>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, md: 2 } }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: { xs: 0, md: 0 },
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Clientes
          </Typography>
        </Box>
        {/* Campo de pesquisa */}
        <Box sx={{ mb: 2 }}>
          <TextField
            label="Pesquisar por ID, Nome ou CNPJ"
            variant="outlined"
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <Button size="small" onClick={clearSearch} sx={{ minWidth: 'auto', p: 0.5 }}>
                    <ClearIcon fontSize="small" />
                  </Button>
                </InputAdornment>
              ),
            }}
            sx={{
              maxWidth: { xs: '100%', sm: 400 },
              '& .MuiOutlinedInput-root': {
                backgroundColor: theme.palette.background.paper,
              },
            }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            mb: 2,
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 0 } }}>
            <Typography
              variant="subtitle1"
              sx={{
                mr: 1,
                fontSize: { xs: '0.875rem', sm: '1rem' },
              }}
            >
              Total de resultados:
            </Typography>
            <Chip
              label={total}
              color="primary"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '0.75rem', sm: '1rem' },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }} />
          {canCreate && (
            <Stack direction="row" spacing={1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  // Reset form ao abrir "Novo Cliente"
                  setForm({
                    nome: '',
                    cnpj: '',
                    email: '',
                    contato: '',
                    endereco: '',
                    ativo: true,
                    agenda_contratos: true,
                  });
                  setOpenModal(true);
                }}
                size={isMobile ? 'small' : 'medium'}
                sx={{
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                {isMobile ? 'Novo Cliente' : 'Criar novo cliente'}
              </Button>
            </Stack>
          )}
        </Box>

        {/* Chips de filtro responsivos */}
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
          <Chip
            label={searchTerm ? `${total} de ${rows.length} clientes` : `${total} clientes`}
            color={searchTerm ? 'secondary' : 'info'}
            size={isMobile ? 'small' : 'medium'}
          />
          {searchTerm && (
            <Chip
              label={`Pesquisando: "${searchTerm}"`}
              color="primary"
              variant="outlined"
              size={isMobile ? 'small' : 'medium'}
              onDelete={clearSearch}
            />
          )}
        </Stack>

        {isMobile ? (
          <>
            {loading ? (
              <Paper sx={{ borderRadius: 2, p: 3, textAlign: 'center' }}>
                <Typography variant="body2">Carregando...</Typography>
              </Paper>
            ) : filteredRows.length === 0 ? (
              <Paper sx={{ borderRadius: 2, p: 3, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ py: 1 }}>
                  {searchTerm
                    ? `Nenhum cliente encontrado para "${searchTerm}"`
                    : 'Nenhum cliente cadastrado'}
                </Typography>
              </Paper>
            ) : (
              <Box>
                {paginatedRows.map((row, idx) => (
                  <Card key={row.id || idx} sx={{ mb: 2, borderRadius: 2 }}>
                    <CardContent>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block' }}
                      >
                        ID: {row.id || '-'}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Cliente: {row.nome || '-'}
                      </Typography>
                      <Typography variant="body2">
                        CNPJ: {maskCnpjForDisplay(row.cnpj || '') || '-'}
                      </Typography>
                      {row.email && <Typography variant="body2">Email: {row.email}</Typography>}
                      {row.contato && (
                        <Typography variant="body2">Contato: {row.contato}</Typography>
                      )}
                      {row.endereco && (
                        <Typography variant="body2">Endereço: {row.endereco}</Typography>
                      )}
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        Budget:{' '}
                        <Typography component="span" sx={{ fontWeight: 700, color: '#1976d2' }}>
                          {parseFloat(row.budget || 0) > 0
                            ? `R$ ${parseFloat(row.budget).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                            : 'Não definido'}
                        </Typography>
                      </Typography>
                      <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        <Chip
                          label={row.ativo === false ? 'Inativo' : 'Ativo'}
                          size="small"
                          color={row.ativo === false ? 'default' : 'success'}
                          variant={row.ativo === false ? 'outlined' : 'filled'}
                        />
                        <Chip
                          label={row.agenda_contratos === false ? 'Agenda off' : 'Agenda on'}
                          size="small"
                          color={row.agenda_contratos === false ? 'default' : 'primary'}
                          variant="outlined"
                        />
                      </Box>
                      <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => setSelectedCliente(row)}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                        {canUpdate && (
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => openEditDialog(row)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                        {canDelete && (
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteClienteByRow(row)}
                            disabled={saving}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            )}
            <Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <TablePagination
                component="div"
                count={filteredRows.length}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas:"
              />
            </Paper>
          </>
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: 0,
              overflowX: { xs: 'auto', md: 'hidden' },
              '& .MuiTable-root': {
                minWidth: { xs: 600, md: '100%' },
              },
            }}
          >
            <Table
              size="medium"
              sx={{
                width: '100%',
                tableLayout: { xs: 'auto', md: 'fixed' },
              }}
            >
              <TableHead>
                <TableRow sx={{ background: '#f4f6f8' }}>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 50, sm: 70 },
                      width: { md: '5%' },
                    }}
                  >
                    ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 100, sm: 150 },
                      width: { md: '16%' },
                    }}
                  >
                    Nome
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 100, sm: 120 },
                      width: { md: '11%' },
                    }}
                  >
                    CNPJ
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 120, sm: 150 },
                      width: { md: '13%' },
                      display: { xs: 'none', sm: 'table-cell' },
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 80, sm: 100 },
                      width: { md: '9%' },
                    }}
                  >
                    Contato
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: { xs: 100, sm: 150 },
                      width: { md: '14%' },
                      display: { xs: 'none', md: 'table-cell' },
                    }}
                  >
                    Endereço
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: 100,
                      width: { md: '10%' },
                    }}
                  >
                    Budget
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: 90,
                      width: { md: '6%' },
                    }}
                  >
                    Ativo
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: 120,
                      width: { md: '7%' },
                    }}
                  >
                    Ag. Contratos
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      minWidth: 80,
                      width: { md: '9%' },
                    }}
                  >
                    Ações
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                      >
                        Carregando...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, py: 2 }}
                      >
                        {searchTerm
                          ? `Nenhum cliente encontrado para "${searchTerm}"`
                          : 'Nenhum cliente cadastrado'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((row, idx) => (
                    <TableRow key={row.id || idx} hover sx={{ borderBottom: '1px solid #e0e0e0' }}>
                      <TableCell sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, fontWeight: 'bold' }}
                        >
                          {row.id || ''}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          maxWidth: { xs: 100, sm: 200, md: 'none' },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: { xs: 'nowrap', md: 'nowrap' },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                        >
                          {row.nome || ''}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                        >
                          {row.cnpj ? maskCnpjForDisplay(row.cnpj) : ''}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: 'none', sm: 'table-cell' },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: { md: 'nowrap' },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.email || ''}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                        >
                          {row.contato || ''}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          display: { xs: 'none', md: 'table-cell' },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.endereco || ''}
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                        >
                          {parseFloat(row.budget || 0) > 0
                            ? `R$ ${parseFloat(row.budget).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                            : '-'}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Chip
                          label={row.ativo === false ? 'Inativo' : 'Ativo'}
                          size="small"
                          color={row.ativo === false ? 'default' : 'success'}
                          variant={row.ativo === false ? 'outlined' : 'filled'}
                        />
                      </TableCell>
                      <TableCell sx={{ whiteSpace: { md: 'nowrap' } }}>
                        <Switch
                          size="small"
                          checked={row.agenda_contratos !== false}
                          onChange={(e) => handleToggleAgendaContratos(row, e.target.checked)}
                          disabled={!canUpdate}
                        />
                      </TableCell>
                      <TableCell sx={{ py: { xs: 1, sm: 1.5 }, whiteSpace: { md: 'nowrap' } }}>
                        <Button
                          size="medium"
                          variant="text"
                          onClick={() => setSelectedCliente(row)}
                          sx={{
                            fontSize: { xs: '0.7rem', sm: '0.875rem' },
                            minWidth: { xs: 'auto', sm: 'auto' },
                            px: { xs: 0.5, sm: 1 },
                          }}
                        >
                          Detalhes
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={filteredRows.length}
              page={page}
              onPageChange={(_, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Linhas por página:"
            />
          </TableContainer>
        )}

        {/* Modal de cadastro */}
        <Dialog
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            // Limpa ao cancelar
            setForm({
              nome: '',
              cnpj: '',
              email: '',
              contato: '',
              endereco: '',
              ativo: true,
              agenda_contratos: true,
            });
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Novo Cliente</DialogTitle>
          <DialogContent>
            <TextField
              label="Nome do Cliente"
              fullWidth
              margin="normal"
              value={form.nome}
              onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))}
              required
            />
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
              <TextField
                label="CPF/CNPJ"
                fullWidth
                margin="normal"
                value={form.cnpj}
                onChange={(e) => setForm((f) => ({ ...f, cnpj: formatCpfCnpj(e.target.value) }))}
                required
              />
              <Button
                variant="outlined"
                sx={{ mt: 2, minWidth: 90, height: 56 }}
                disabled={buscandoCnpj || (form.cnpj || '').replace(/\D/g, '').length !== 14}
                onClick={() => handleBuscarCnpj(form.cnpj, setForm)}
              >
                {buscandoCnpj ? 'Buscando…' : 'Buscar'}
              </Button>
            </Box>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            />
            <TextField
              label="Contato/Telefone"
              fullWidth
              margin="normal"
              value={form.contato}
              onChange={(e) => setForm((f) => ({ ...f, contato: e.target.value }))}
            />
            <TextField
              label="Endereço"
              fullWidth
              margin="normal"
              value={form.endereco}
              onChange={(e) => setForm((f) => ({ ...f, endereco: e.target.value }))}
            />
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}
            >
              <Typography variant="body2">Cliente ativo</Typography>
              <Switch
                checked={form.ativo !== false}
                onChange={(e) => setForm((f) => ({ ...f, ativo: e.target.checked }))}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body2">Incluir na agenda de contratos</Typography>
              <Switch
                checked={form.agenda_contratos !== false}
                onChange={(e) => setForm((f) => ({ ...f, agenda_contratos: e.target.checked }))}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenModal(false);
                setForm({ nome: '', cnpj: '', email: '', contato: '', endereco: '' });
              }}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleCreateCliente}
              disabled={saving || !form.nome || !form.cnpj}
            >
              {saving ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de detalhes/edição */}
        <Dialog
          open={!!selectedCliente && !openEditModal}
          onClose={() => setSelectedCliente(null)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
        >
          <DialogTitle>Detalhes do Cliente</DialogTitle>
          <DialogContent>
            {selectedCliente && (
              <Box sx={{ pt: 1 }}>
                <Typography sx={{ mb: 1 }}>
                  <strong>ID:</strong> {selectedCliente.id}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Nome:</strong> {selectedCliente.nome}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>CNPJ:</strong> {selectedCliente.cnpj || 'Não informado'}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Email:</strong> {selectedCliente.email || 'Não informado'}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Contato:</strong> {selectedCliente.contato || 'Não informado'}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Endereço:</strong> {selectedCliente.endereco || 'Não informado'}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Status:</strong> {selectedCliente.ativo === false ? 'Inativo' : 'Ativo'}
                </Typography>
                <Typography sx={{ mb: 1 }}>
                  <strong>Agenda de Contratos:</strong>{' '}
                  {selectedCliente.agenda_contratos === false ? 'Desativada' : 'Ativada'}
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    bgcolor: '#f5f5f5',
                    borderRadius: 2,
                    border: '1px solid #e0e0e0',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Budget
                    </Typography>
                    <Box>
                      <Tooltip title="Histórico de alterações">
                        <IconButton
                          size="small"
                          onClick={() => handleOpenHistorico(selectedCliente.id)}
                        >
                          <HistoryIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      {isAdmin && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => handleOpenBudget(selectedCliente)}
                        >
                          Alterar Budget
                        </Button>
                      )}
                    </Box>
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#1976d2' }}>
                    {parseFloat(selectedCliente.budget || 0) > 0
                      ? `R$ ${parseFloat(selectedCliente.budget).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                      : 'Não definido'}
                  </Typography>
                </Box>
                {/* Planta Baixa - Multi-plantas */}
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    bgcolor: '#f5f5f5',
                    borderRadius: 2,
                    border: '1px solid #e0e0e0',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      <MapIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                      Plantas Baixas
                    </Typography>
                    <Button
                      size="small"
                      variant="text"
                      startIcon={<ArchiveIcon />}
                      onClick={() => {
                        setShowArquivadas(!showArquivadas);
                        if (!showArquivadas) loadPlantasArquivadas(selectedCliente.id);
                      }}
                    >
                      {showArquivadas ? 'Ocultar Arquivadas' : 'Ver Arquivadas'}
                    </Button>
                  </Box>
                  {/* Upload de nova planta */}
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1.5 }}>
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                      <InputLabel>Nível</InputLabel>
                      <Select
                        value={plantaUploadNivel}
                        label="Nível"
                        onChange={(e) => setPlantaUploadNivel(e.target.value)}
                      >
                        {NIVEIS_PLANTA.map((n) => (
                          <MenuItem key={n.value} value={n.value}>
                            {n.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <input
                      type="file"
                      accept=".pdf,.png,.jpg,.jpeg,.webp"
                      ref={plantaInputRef}
                      onChange={handleUploadPlanta}
                      style={{ display: 'none' }}
                    />
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={
                        uploadingPlanta ? <CircularProgress size={16} /> : <CloudUploadIcon />
                      }
                      onClick={() => plantaInputRef.current && plantaInputRef.current.click()}
                      disabled={uploadingPlanta || !plantaUploadNivel}
                    >
                      Enviar Planta
                    </Button>
                  </Box>
                  {uploadingPlanta && (
                    <Box sx={{ mb: 1.5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={uploadProgress}
                          sx={{ flex: 1, height: 8, borderRadius: 4 }}
                        />
                        <Typography
                          variant="body2"
                          color="primary"
                          sx={{ fontWeight: 700, minWidth: 40 }}
                        >
                          {uploadProgress}%
                        </Typography>
                      </Box>
                      <Typography variant="caption" color="text.secondary">
                        {uploadProgress < 90
                          ? 'Enviando arquivo...'
                          : uploadProgress < 100
                            ? 'Convertendo planta...'
                            : 'Concluído!'}
                      </Typography>
                    </Box>
                  )}
                  {/* Lista de plantas ativas */}
                  {plantasList.length > 0 ? (
                    <Stack spacing={1}>
                      {plantasList
                        .filter((p) => !p.arquivada)
                        .map((planta) => (
                          <Box
                            key={planta.id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              p: 1,
                              bgcolor: '#fff',
                              borderRadius: 1,
                              border: '1px solid #e0e0e0',
                            }}
                          >
                            {planta.planta_imagem && (
                              <Box
                                sx={{
                                  width: 60,
                                  height: 40,
                                  borderRadius: 0.5,
                                  overflow: 'hidden',
                                  cursor: 'pointer',
                                  flexShrink: 0,
                                }}
                                onClick={() => {
                                  setSelectedPlantaId(planta.id);
                                  handleOpenPlanta(selectedCliente.id);
                                }}
                              >
                                <img
                                  src={planta.planta_imagem}
                                  alt={planta.nivel_display}
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                              </Box>
                            )}
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {planta.nivel_display}
                              </Typography>
                              {planta.nome && (
                                <Typography variant="caption" color="text.secondary">
                                  {planta.nome}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                              <Tooltip title="Ver planta com chamados">
                                <IconButton
                                  size="small"
                                  color="info"
                                  onClick={() => {
                                    setSelectedPlantaId(planta.id);
                                    handleOpenPlanta(selectedCliente.id);
                                  }}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Baixar planta em PDF">
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => handleBaixarPlantaPDF(planta)}
                                  startIcon={<PictureAsPdfIcon fontSize="small" />}
                                  sx={{ minWidth: 56, px: 1, fontSize: '0.75rem', lineHeight: 1 }}
                                >
                                  PDF
                                </Button>
                              </Tooltip>
                              <Tooltip title="Arquivar">
                                <IconButton
                                  size="small"
                                  color="warning"
                                  onClick={() => handleArquivarPlanta(planta.id)}
                                >
                                  <ArchiveIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Excluir permanentemente">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleRemoverPlanta(planta.id)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        ))}
                    </Stack>
                  ) : (
                    <Typography color="text.secondary" variant="body2">
                      Nenhuma planta cadastrada. Selecione o nível e envie um PDF ou imagem.
                    </Typography>
                  )}
                  {/* Plantas arquivadas */}
                  {showArquivadas && plantasArquivadas.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 700, mb: 1, color: 'text.secondary' }}
                      >
                        <ArchiveIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                        Plantas Arquivadas
                      </Typography>
                      <Stack spacing={1}>
                        {plantasArquivadas.map((planta) => (
                          <Box
                            key={planta.id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              p: 1,
                              bgcolor: '#fafafa',
                              borderRadius: 1,
                              border: '1px dashed #ccc',
                              opacity: 0.8,
                            }}
                          >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {planta.nivel_display}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Arquivada em: {planta.arquivada_em || '—'}
                              </Typography>
                            </Box>
                            <Tooltip title="Desarquivar">
                              <IconButton
                                size="small"
                                color="success"
                                onClick={() => handleDesarquivarPlanta(planta.id)}
                              >
                                <UnarchiveIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  )}
                  {showArquivadas && plantasArquivadas.length === 0 && (
                    <Typography
                      color="text.secondary"
                      variant="caption"
                      sx={{ mt: 1, display: 'block' }}
                    >
                      Nenhuma planta arquivada.
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectedCliente(null)} disabled={saving}>
              Fechar
            </Button>
            {canUpdate && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => openEditDialog(selectedCliente)}
                disabled={saving}
              >
                Editar
              </Button>
            )}
            {canDelete && (
              <Button
                variant="outlined"
                color="error"
                onClick={handleDeleteCliente}
                disabled={saving}
              >
                {saving ? 'Deletando...' : 'Deletar'}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Modal de edição */}
        <Dialog
          open={openEditModal}
          onClose={() => {
            setOpenEditModal(false);
            // Limpa edição ao cancelar
            setEditForm({
              nome: '',
              cnpj: '',
              email: '',
              contato: '',
              endereco: '',
              ativo: true,
              agenda_contratos: true,
            });
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Editar Cliente</DialogTitle>
          <DialogContent>
            <TextField
              label="Nome do Cliente"
              fullWidth
              margin="normal"
              value={editForm.nome}
              onChange={(e) => setEditForm((f) => ({ ...f, nome: e.target.value }))}
              required
            />
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
              <TextField
                label="CPF/CNPJ"
                fullWidth
                margin="normal"
                value={editForm.cnpj}
                onChange={(e) =>
                  setEditForm((f) => ({ ...f, cnpj: formatCpfCnpj(e.target.value) }))
                }
                required
              />
              <Button
                variant="outlined"
                sx={{ mt: 2, minWidth: 90, height: 56 }}
                disabled={buscandoCnpj || (editForm.cnpj || '').replace(/\D/g, '').length !== 14}
                onClick={() => handleBuscarCnpj(editForm.cnpj, setEditForm)}
              >
                {buscandoCnpj ? 'Buscando…' : 'Buscar'}
              </Button>
            </Box>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={editForm.email}
              onChange={(e) => setEditForm((f) => ({ ...f, email: e.target.value }))}
            />
            <TextField
              label="Contato/Telefone"
              fullWidth
              margin="normal"
              value={editForm.contato}
              onChange={(e) => setEditForm((f) => ({ ...f, contato: e.target.value }))}
            />
            <TextField
              label="Endereço"
              fullWidth
              margin="normal"
              value={editForm.endereco}
              onChange={(e) => setEditForm((f) => ({ ...f, endereco: e.target.value }))}
            />
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}
            >
              <Typography variant="body2">Cliente ativo</Typography>
              <Switch
                checked={editForm.ativo !== false}
                onChange={(e) => setEditForm((f) => ({ ...f, ativo: e.target.checked }))}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body2">Incluir na agenda de contratos</Typography>
              <Switch
                checked={editForm.agenda_contratos !== false}
                onChange={(e) => setEditForm((f) => ({ ...f, agenda_contratos: e.target.checked }))}
              />
            </Box>
            {/* Planta Baixa no Editar - Multi-plantas */}
            <Box
              sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2, border: '1px solid #e0e0e0' }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1,
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                  <MapIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                  Plantas Baixas
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel>Nível</InputLabel>
                  <Select
                    value={plantaUploadNivel}
                    label="Nível"
                    onChange={(e) => setPlantaUploadNivel(e.target.value)}
                  >
                    {NIVEIS_PLANTA.map((n) => (
                      <MenuItem key={n.value} value={n.value}>
                        {n.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <input
                  type="file"
                  accept=".pdf,.png,.jpg,.jpeg,.webp"
                  ref={plantaInputRef}
                  onChange={handleUploadPlanta}
                  style={{ display: 'none' }}
                />
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={uploadingPlanta ? <CircularProgress size={16} /> : <CloudUploadIcon />}
                  onClick={() => plantaInputRef.current && plantaInputRef.current.click()}
                  disabled={uploadingPlanta || !plantaUploadNivel}
                >
                  {uploadingPlanta ? 'Enviando...' : 'Enviar Planta'}
                </Button>
              </Box>
              {uploadingPlanta && (
                <Box sx={{ mb: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={uploadProgress}
                      sx={{ flex: 1, height: 8, borderRadius: 4 }}
                    />
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{ fontWeight: 700, minWidth: 40 }}
                    >
                      {uploadProgress}%
                    </Typography>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    {uploadProgress < 90
                      ? 'Enviando arquivo...'
                      : uploadProgress < 100
                        ? 'Convertendo planta...'
                        : 'Concluído!'}
                  </Typography>
                </Box>
              )}
              {plantasList.filter((p) => !p.arquivada).length > 0 ? (
                <Stack spacing={0.5}>
                  {plantasList
                    .filter((p) => !p.arquivada)
                    .map((planta) => (
                      <Box
                        key={planta.id}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          p: 0.5,
                          bgcolor: '#fff',
                          borderRadius: 1,
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <Typography variant="body2" sx={{ flex: 1, fontWeight: 600 }}>
                          {planta.nivel_display}
                        </Typography>
                        <Tooltip title="Ver planta">
                          <IconButton
                            size="small"
                            color="info"
                            onClick={() => {
                              setSelectedPlantaId(planta.id);
                              handleOpenPlanta(selectedCliente.id);
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Arquivar">
                          <IconButton
                            size="small"
                            color="warning"
                            onClick={() => handleArquivarPlanta(planta.id)}
                          >
                            <ArchiveIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleRemoverPlanta(planta.id)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    ))}
                </Stack>
              ) : (
                <Typography color="text.secondary" variant="body2">
                  Nenhuma planta cadastrada.
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenEditModal(false);
                setEditForm({
                  nome: '',
                  cnpj: '',
                  email: '',
                  contato: '',
                  endereco: '',
                  ativo: true,
                  agenda_contratos: true,
                });
              }}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleUpdateCliente}
              disabled={saving || !editForm.nome || !editForm.cnpj}
            >
              {saving ? 'Atualizando...' : 'Atualizar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Budget (admin only) */}
        <Dialog
          open={openBudgetModal}
          onClose={() => setOpenBudgetModal(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Alterar Budget</DialogTitle>
          <DialogContent>
            <TextField
              label="Valor do Budget (R$)"
              type="number"
              fullWidth
              margin="normal"
              value={budgetForm.budget}
              onChange={(e) => setBudgetForm((f) => ({ ...f, budget: e.target.value }))}
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
            />
            <TextField
              label="Motivo da alteração"
              fullWidth
              margin="normal"
              multiline
              rows={2}
              value={budgetForm.motivo}
              onChange={(e) => setBudgetForm((f) => ({ ...f, motivo: e.target.value }))}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenBudgetModal(false)} disabled={saving}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={handleSaveBudget} disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Histórico de Budget */}
        <Dialog
          open={openHistoricoModal}
          onClose={() => setOpenHistoricoModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Histórico de Budget</DialogTitle>
          <DialogContent>
            {budgetHistorico.length === 0 ? (
              <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                Nenhuma alteração registrada.
              </Typography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>Data</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Usuário</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                      Anterior
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                      Novo
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Motivo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {budgetHistorico.map((h) => (
                    <TableRow key={h.id}>
                      <TableCell>{h.data}</TableCell>
                      <TableCell>{h.usuario_nome}</TableCell>
                      <TableCell align="right">
                        R${' '}
                        {parseFloat(h.valor_anterior).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell align="right">
                        R${' '}
                        {parseFloat(h.valor_novo).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell>{h.motivo || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenHistoricoModal(false)}>Fechar</Button>
          </DialogActions>
        </Dialog>
        {/* Modal de Planta Baixa - Multi-plantas */}
        <Dialog
          open={openPlantaModal}
          onClose={() => setOpenPlantaModal(false)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="h6">
                <MapIcon sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                Planta - {selectedCliente?.nome}
              </Typography>
              {(() => {
                const sel = plantasList.find((p) => p.id === selectedPlantaId);
                const count = sel?.chamados?.length || 0;
                return <Chip label={`${count} chamado(s) marcado(s)`} color="info" size="small" />;
              })()}
            </Box>
          </DialogTitle>
          <DialogContent>
            {plantaLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : plantasList.filter((p) => !p.arquivada).length > 0 ? (
              <>
                <Tabs
                  value={selectedPlantaId || false}
                  onChange={(_, v) => setSelectedPlantaId(v)}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}
                >
                  {plantasList
                    .filter((p) => !p.arquivada)
                    .map((p) => (
                      <Tab key={p.id} value={p.id} label={p.nivel_display} />
                    ))}
                </Tabs>
                {(() => {
                  const sel = plantasList.find((p) => p.id === selectedPlantaId);
                  if (!sel)
                    return <Typography color="text.secondary">Selecione uma planta</Typography>;
                  return (
                    <PlantaViewer
                      imagemUrl={sel.planta_imagem}
                      chamados={sel.chamados || []}
                      height={550}
                    />
                  );
                })()}
              </>
            ) : (
              <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
                Nenhuma planta ativa cadastrada para este cliente.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPlantaModal(false)}>Fechar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
